import React from 'react'
import { Label, Paragraph, TxtLink } from 'atoms/Texts'
import { FormMail } from 'atoms/Inputs'
import { ButtonReg } from 'atoms/Buttons'
import { EmailRow, BtnRow } from './styles'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

const PasswordForgotForm = props => {
  const {
    fnOnChange,
    fnOnSubmit,
    btnLabel,
    isBtnDisabled,
    isShowForm,
    msg
  } = props

  return (
    <div>
      {isShowForm ?
        <form onSubmit={fnOnSubmit}>
          <EmailRow>
            <Label mb={'12px'}>
              Enter the email address associated with your account.
            </Label>
            <FormMail onChangeVal={e => fnOnChange(e.target.value, 'email')} />
          </EmailRow>
          <BtnRow>
            <ButtonReg
              btnTxt={btnLabel}
              disabled={isBtnDisabled}
              onClick={fnOnSubmit}
              btnType={'submit'}
            />
          </BtnRow>
        </form> :
        <div style={{ marginTop: '32px' }}>
          {msg.split('\n').map((msgs, i) =>
            <Paragraph key={i} size={'14px'}>{msgs}</Paragraph>
          )}

          <TxtLink href={'#'} onClick={fnOnSubmit}>
            I didn’t receive the email
          </TxtLink>
        </div>
      }
    </div>
  )
}

export default withRouter(
  withTheme(PasswordForgotForm)
)
